<template>
  <div>
    <el-dialog
      :title="dialogTitle"
      :visible="dialog"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="close"
      @open="open"
    >
      <el-form :model="campaign_highlight" label-position="top" >
        <el-form-item label="Type" prop="type" >
          <el-select v-model="campaign_highlight.type" @change="onTypeChange" clearable filterable class="mr10">
            <el-option  value="artist"  label="Artist" ></el-option>
            <el-option  value="creator"  label="Creator" ></el-option>
            <el-option  value="partner"  label="Partner" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!retType(campaign_highlight.type)" label="Name" prop="name">
          <el-input type="text" v-model="campaign_highlight.name" clearable />
        </el-form-item>
        <el-form-item
          :label="labelNameArtist"
          prop="artist_id"
          v-if="campaign_highlight.type!=='partner'"
        >
          <el-select v-model="campaign_highlight.artist_id" clearable filterable class="mr10">
            <el-option
              v-for="a in artists.data"
              :key="a.id"
              :value="a.id"
              :label="a.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="Name"
          prop="partner_id"
          v-if="campaign_highlight.type=='partner'"
        >
          <el-select v-model="campaign_highlight.partner_id" clearable filterable class="mr10">
            <el-option
              v-for="a in partners.data"
              :key="a.id"
              :value="a.id"
              :label="a.first_name+' '+a.surname"
            ></el-option>
          </el-select>
        </el-form-item>
        <div v-if="selectedPartner && campaign_highlight.type=='partner'">
          <el-form-item label="Country" prop="country">
              <el-input v-model="selectedPartner.country_of_residence" placeholder="Partner Data" readonly></el-input>
          </el-form-item>
          <el-form-item label="Subscriber reach" prop="subscriber_reach">
            <el-input type="text" v-model="selectedPartner.total_follower_count"/>
          </el-form-item>
        </div>
        <el-form-item label="Country" prop="country"  v-if="!isPartner()">
          <el-input type="text" v-model="campaign_highlight.country" clearable />
        </el-form-item>
<!--        <el-form-item label="Country" prop="country"  v-else>
          <el-input type="text" v-model="campaign_highlight[0].country_of_residence" clearable />
        </el-form-item>-->
        <div class="custom-field" v-if="!isPartner()">
          <el-form-item label="Genre" prop="genre">
            <el-input type="text" v-model="campaign_highlight.genre" clearable />
          </el-form-item>
          <el-form-item v-if="retType(campaign_highlight.type)" label="Track title" prop="track_title">
            <el-input type="text" v-model="campaign_highlight.track_title" clearable />
          </el-form-item>
          <el-form-item v-else label="Track used" prop="track_used">
            <el-input type="text" v-model="campaign_highlight.track_used" clearable />
          </el-form-item>
          <el-form-item v-if="retType(campaign_highlight.type)" label="Video placement" prop="video_placement">
            <el-input type="text" v-model="campaign_highlight.video_placement" clearable />
          </el-form-item>
          <el-form-item v-if="retType(campaign_highlight.type)" label="Campaign views" prop="campaign_views">
            <el-input type="text" v-model="campaign_highlight.campaign_views" clearable />
          </el-form-item>
          <el-form-item v-if="retType(campaign_highlight.type)" label="Subscriber reach" prop="subscriber_reach">
            <el-input type="text" v-model="campaign_highlight.subscriber_reach" clearable />
          </el-form-item>
          <el-form-item v-if="retType(campaign_highlight.type)" label="Audience territories" prop="audience_territories">
            <el-input type="text" v-model="campaign_highlight.audience_territories" clearable />
          </el-form-item>
        </div>
        <div>
          <p class="inline-eye">Quote</p>
          <i class="el-icon-view ml10" @click="openPreview(campaign_highlight.quote)"></i>
        </div>
        <el-form-item prop="text">
          <vue-editor v-model="campaign_highlight.quote" :editorToolbar="customToolbar" />
        </el-form-item>
        <el-form-item v-if="!retType(campaign_highlight.type)" label="Video views" prop="video_views">
          <el-input type="text" v-model="campaign_highlight.video_views" clearable />
        </el-form-item>
        <el-form-item v-if="!retType(campaign_highlight.type)" label="Channel subscribers" prop="channel_subscribers">
          <el-input type="text" v-model="campaign_highlight.channel_subscribers" clearable />
        </el-form-item>
        <el-form-item v-if="!retType(campaign_highlight.type)" label="Link" prop="link">
          <el-input type="text" v-model="campaign_highlight.link" clearable />
        </el-form-item>
        <el-form-item v-if="!retType(campaign_highlight.type)" label="Link title" prop="link_name">
          <el-input type="text" v-model="campaign_highlight.link_name" clearable />
        </el-form-item>
        <div>
          <p>Image</p>
          <el-upload
            :action="`${url}cms/campaign-highlight/upload`"
            :headers="headers"
            accept="image/*"
            :on-success="onSuccess"
            :on-error="onError"
            :on-remove="onRemove"
            :on-exceed="onExceed"
            :limit="1"
            :file-list="fileList"
            list-type="picture"
          >
            <el-button size="small" type="primary">Click to upload</el-button>
            <div slot="tip" class="el-upload__tip">jpg/jpeg/png files</div>
          </el-upload>
        </div>
      </el-form>
      <div slot="footer">
        <el-button
          type="primary"
          size="mini"
          :loading="loading"
          @click="submit()"
        >
          Save
        </el-button>
      </div>
    </el-dialog>
    <Preview :previewText="text"/>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { VueEditor } from 'vue2-editor'
import Preview from '@/global/components/Preview'

export default {
  components: {
    VueEditor,
    Preview
  },

  data() {
    return {
      text: '',
      fileList: [],
      url: process.env.VUE_APP_ADMIN_API_URL,
      headers: { Authorization: 'Bearer ' + localStorage.getItem('token') },
      image: { name: '', url: '' }    ,
      labelNameArtist: 'artist',
    }
  },

  computed: {
    dialogTitle: function() {
      if (typeof this.campaign_highlight.id !== 'undefined' && this.campaign_highlight.id !== null)
        return 'Edit Campaign Highlight'
      else {
        return 'Insert Campaign Highlight'
      }
    },
    selectedPartner() {
      const partnerId = this.campaign_highlight.partner_id;
      if (partnerId) {
        // Find the selected partner from the partners array
        const selectedPartner = this.partners.data.find(partner => partner.id === partnerId);
        return selectedPartner || null;
      }
      return null;
    },
    ...mapState('campaignHighlight', [
      'loading',
      'campaign_highlight',
      'dialog',
      'artists',
      'partners'
    ])
  },

  methods: {
    ...mapActions('campaignHighlight', ['update', 'insert', 'getArtists', 'getPartners']),
    ...mapMutations('campaignHighlight', [
      'setSelectedCampaign',
      'setDialog'
    ]),
    ...mapMutations('global', ['setPreview']),

    submit() {
      if(this.campaign_highlight.type == 'partner'){
        this.campaign_highlight.name = this.selectedPartner.first_name+' '+this.selectedPartner.surname
        this.campaign_highlight.subscriber_reach = this.selectedPartner.total_follower_count
        this.campaign_highlight.country = this.selectedPartner.country_of_residence
      }
      if (typeof this.campaign_highlight.id !== 'undefined' && this.campaign_highlight.id !== null){
        this.update(this.campaign_highlight.id)
      }
      else this.insert()
    },

    onSuccess(response, file) {
      this.campaign_highlight.image_url = response.response.message
      this.$message({
        type: 'success',
        message: `File ${file.name} uploaded`
      })
    },

    onError(err) {
      var res = JSON.parse(err.message)
      this.$message({
        type: 'error',
        message: res ? res.response.message : 'Upload error!'
      })
    },

    onRemove() {
      this.campaign_highlight.image_url = null
    },

    onExceed() {
      this.$message({
        type: 'error',
        message: 'Only one image can be uploaded'
      })
    },

    open() {
      this.fileList = []
      if (
        typeof this.campaign_highlight.image_url !== 'undefined' &&
        this.campaign_highlight.image_url !== null
      ) {
        this.image.url = this.campaign_highlight.image_url
        //this.image.name = this.image.url.substr(this.image.url.lastIndexOf("/")+1)
        this.fileList.push(this.image)
      }
      if(this.campaign_highlight.type == 'artist'){
        this.labelNameArtist = 'Name'
      }
      else{
        this.labelNameArtist = 'Artist'
      }
    },

    openPreview(sometext) {
      this.setPreview(true)
      this.text = sometext
    },

    close(){
      this.setDialog(false)
    },

    retType(type) {
      if (type === 'artist' || type === 'partner')
        return true
      else {
        return false
      }
    },

    selected(name){
      if(this.campaign_highlight.type == 'artist')
        this.campaign_highlight.name = name
    },

    onTypeChange(){
      if(this.campaign_highlight.type == 'artist'){
        this.labelNameArtist = 'Name'
      }
      else{
        this.labelNameArtist = 'Artist'
      }
    },

    isPartner(){
      if(this.campaign_highlight.type == 'partner'){
        return true
      }
      else{
        return false
      }
    },
    country() {
      if (this.campaign_highlight.type == "partner") {
        return this.campaign_highlight.type.country_of_residence;
      } else {
        return this.campaign_highlight.type.country;
      }
    },

  },
  created() {
    this.getArtists()
    this.getPartners()
  }
}
</script>

<style scoped>
.inline-eye {
  display: inline-block;
}
</style>
